/*
 * consent-embed.js — two-click embeds for third-party iframes (e.g. Google Maps)
 *
 * Markup (lives in page content; all visible text comes from there):
 *   <div class="consent-embed" data-embed-src="https://…" data-embed-title="…"
 *        data-embed-allow="vr"> (optional: copied to the iframe's allow attribute)
 *   Layout modifiers (CSS): --aside (354px beside text on desktop),
 *   --wide (full width, 16:9, min 480px high on desktop; e.g. 3D tours).
 *     <div class="consent-embed__placeholder">
 *       …text… <button type="button" class="btn consent-embed__load">…</button> …
 *     </div>
 *   </div>
 *
 * Behaviour:
 *   - Visitor has explicitly granted MARKETING consent in Shopify's cookie banner
 *     (Customer Privacy API: currentVisitorConsent().marketing === 'yes')
 *     → the iframe is loaded automatically.
 *   - Otherwise the placeholder stays; clicking .consent-embed__load loads the
 *     iframe for this page view only (global consent is not touched).
 *   - Accepting marketing in the banner while on the page loads it immediately
 *     (document event 'visitorConsentCollected').
 *   Nothing is requested from the third party until one of the above happens.
 *
 * Explicit 'yes' is required on purpose: marketingAllowed() is also true in
 * regions without a consent requirement, which would load Google without consent.
 */
(function () {
  'use strict';

  var ROOT = '.consent-embed';

  function load(el) {
    if (el.classList.contains('consent-embed--loaded')) return;
    var src = el.getAttribute('data-embed-src');
    if (!src) return;
    var frame = document.createElement('iframe');
    frame.className = 'consent-embed__frame';
    frame.src = src;
    frame.title = el.getAttribute('data-embed-title') || '';
    var allow = el.getAttribute('data-embed-allow');
    if (allow) frame.setAttribute('allow', allow);
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    frame.setAttribute('loading', 'lazy');
    el.appendChild(frame);
    el.classList.add('consent-embed--loaded');
  }

  function loadAll() {
    var els = document.querySelectorAll(ROOT);
    for (var i = 0; i < els.length; i++) load(els[i]);
  }

  function hasMarketingConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
    var consent = cp.currentVisitorConsent();
    return !!consent && consent.marketing === 'yes';
  }

  function init() {
    if (!document.querySelector(ROOT)) return;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.consent-embed__load');
      if (!btn) return;
      var el = btn.closest(ROOT);
      if (!el) return;
      e.preventDefault();
      load(el);
    });

    // Fired by Shopify only when the visitor changes consent (banner or preferences).
    document.addEventListener('visitorConsentCollected', function (e) {
      if (e.detail && e.detail.marketingAllowed) loadAll();
    });

    var check = function () { if (hasMarketingConsent()) loadAll(); };
    if (window.Shopify && window.Shopify.customerPrivacy) {
      check();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) { if (!error) check(); }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
